// Error page strings — namespace `errors`
// Covers: ForbiddenPage (403), NotFoundPage (404), ServerErrorPage (500/502/503).
//
// The footer under every error page is AuthFooter (auth.footer.*).

export default {
  en: {
    logoAriaLabel: 'GAMZOR home',


    forbidden: {
      heading: "You don't have permission",
      description: "You're signed in, but this page is off-limits. If you think this is a mistake, contact support.",
      descriptionSignedOut: 'This page needs an account with access. Sign in and we will take it from there.',
      signIn: 'Sign in',
      backHome: 'Back home',
      browseCatalog: 'Browse catalog',
      contactSupport: 'Contact support',
    },

    notFound: {
      heading: 'Page not found',
      description: "The page you're looking for doesn't exist or has moved. Try browsing the catalog instead.",
      backHome: 'Back home',
      browseCatalog: 'Browse catalog',
      popular: 'Popular right now',
    },

    serverError: {
      // Headline variants — chosen by the view's computed property
      headlineMaintenance: "We'll be right back",
      headline500: 'Something went wrong',
      headlineConnecting: "We're having trouble connecting",

      // Detail variants
      detailMaintenance: 'GAMZOR is briefly offline for maintenance. Please check back in a few minutes.',
      detail500: "An unexpected error occurred. We've been notified — please try again.",
      detailConnecting: 'Our service is temporarily unavailable. Try again in a moment.',

      retry: 'Retry',
      backHome: 'Back home',
    },
  },

  cs: {
    logoAriaLabel: 'Domovská stránka GAMZOR',


    forbidden: {
      heading: 'Nemáte oprávnění',
      description: 'Jste přihlášeni, ale tato stránka je pro vás nepřístupná. Pokud si myslíte, že jde o chybu, kontaktujte podporu.',
      descriptionSignedOut: 'Tato stránka vyžaduje účet s přístupem. Přihlaste se a budeme pokračovat.',
      signIn: 'Přihlásit se',
      backHome: 'Zpět na úvod',
      browseCatalog: 'Procházet katalog',
      contactSupport: 'Kontaktovat podporu',
    },

    notFound: {
      heading: 'Stránka nenalezena',
      description: 'Stránka, kterou hledáte, neexistuje nebo byla přesunuta. Zkuste procházet katalog.',
      backHome: 'Zpět na úvod',
      browseCatalog: 'Procházet katalog',
      popular: 'Právě populární',
    },

    serverError: {
      headlineMaintenance: 'Hned se vrátíme',
      headline500: 'Něco se pokazilo',
      headlineConnecting: 'Máme potíže s připojením',

      detailMaintenance: 'GAMZOR je krátce offline z důvodu údržby. Zkuste to prosím za několik minut.',
      detail500: 'Došlo k neočekávané chybě. Byli jsme upozorněni — zkuste to prosím znovu.',
      detailConnecting: 'Naše služba je dočasně nedostupná. Zkuste to znovu za chvíli.',

      retry: 'Zkusit znovu',
      backHome: 'Zpět na úvod',
    },
  },
};
